import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { ILanguage, ILanguagesListKeys } from '../model/languagesList';

export const facilityAvailableLanguagesListKey = (keys: ILanguagesListKeys): [string, string] => [
  'facilityAvailableLanguagesList',
  keys.locationId,
];

export const facilityAvailableLanguagesListFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof facilityAvailableLanguagesListKey>>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/language/facility/${queryKey[1]}`);

const facilityAvailableLanguagesListSelect = ({ data }: AxiosResponse<{ data: ILanguage[] }>) =>
  data?.data || [];

export const useFacilityAvailableLanguagesListQuery = (keys: ILanguagesListKeys) => {
  return useQuery({
    queryKey: facilityAvailableLanguagesListKey(keys),
    queryFn: facilityAvailableLanguagesListFn,
    enabled: !!keys.locationId,
    select: facilityAvailableLanguagesListSelect,
  });
};
